import { HYDRATE } from 'next-redux-wrapper';
import { THydrateAction } from '~/src/store';

export const FETCH_FAQ_CATEGORIES = 'FETCH_FAQ_CATEGORIES';
export const SET_FAQ_CATEGORIES = 'SET_FAQ_CATEGORIES';
export const ERROR_FAQ_CATEGORIES = 'ERROR_FAQ_CATEGORIES';
export const FETCH_FAQ_ARTICLES = 'FETCH_FAQ_ARTICLES';
export const SET_FAQ_ARTICLES = 'SET_FAQ_ARTICLES';
export const ERROR_FAQ_ARTICLES = 'ERROR_FAQ_ARTICLES';

export interface ICategory {
    category_id: number,
    category_name: string,
}

export interface IArticleName {
    faq_id: number,
    question: string,
    categories: Array<ICategory>,
}

export interface IArticlesByCategory {
    [categoryId:number]: IArticleName[],
}

interface IFaqState {
    categories: ICategory[],
    categoriesPlaces: Array<number>,
    categoriesFetching: boolean,
    categoriesError: string | undefined | null,

    articles: IArticlesByCategory,
    articlesPlaces: Array<number>,
    articlesFetching: boolean,
    articlesError: string | undefined | null,
}

const initialState:IFaqState = {
    categories: [],
    categoriesPlaces: [],
    categoriesFetching: false,
    categoriesError: null,

    articles: {},
    articlesPlaces: [],
    articlesFetching: false,
    articlesError: null,
};

export type TActions = {
    type:
        typeof FETCH_FAQ_CATEGORIES |
        typeof SET_FAQ_CATEGORIES |
        typeof ERROR_FAQ_CATEGORIES |
        typeof FETCH_FAQ_ARTICLES |
        typeof SET_FAQ_ARTICLES |
        typeof ERROR_FAQ_ARTICLES,
    payload: Partial<IFaqState>,
};

type State = {
    [key: string]: any,
};

export default (state = initialState, action: TActions | THydrateAction): State => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.faq };
        case FETCH_FAQ_CATEGORIES: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case SET_FAQ_CATEGORIES: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case ERROR_FAQ_CATEGORIES: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case FETCH_FAQ_ARTICLES: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case SET_FAQ_ARTICLES: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case ERROR_FAQ_ARTICLES: {
            return {
                ...state,
                ...action.payload,
            };
        }

        default: return state;
    }
};
